import { compose, defaultTo, isNil, replace, slice, split } from 'ramda';
import { isNilOrEmptyString, isNumeric } from 'ramda-extension';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { EMPTY_VALUES } from 'constants/general';

import { equalOrThreeDashes, equalOrZero } from './equalOrThreeDashes';

const DEFAULT_DECIMALS = 2;

export const formatNumber = (number) => {
	if (isNil(number)) {
		return '';
	}

	return number
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
		.replace('.', ',');
};

export const formatPhoneNumber = (phone) => defaultTo(EMPTY_VALUES.STRING, phone).replace(/\s+/g, EMPTY_VALUES.STRING);

const roundNumber = (decimals) => (number) => {
	if (isNil(number)) {
		return null;
	}

	if (isNil(decimals)) {
		decimals = DEFAULT_DECIMALS;
	}

	const round = Number(
		parseFloat(Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals),
	);

	// if have decimal number
	if (Math.abs(round) % 1 > 0) {
		return round.toFixed(decimals);
	}

	return round;
};

export const number = (number, decimals) => {
	return isNil(number) ? '---' : compose(formatNumber, roundNumber(decimals))(number);
};

export const nonEmptyNumber = (number, decimals) => {
	return isNilOrEmptyString(number) ? '---' : compose(formatNumber, roundNumber(decimals))(number);
};

export const checkPhoneLength = (number) => {
	return number.length > 9 ? slice(number.length - 9, Infinity, number) : number;
};

export const currency = (number, decimals, showZero = false) =>
	compose(
		(n) => `${showZero ? equalOrZero(n) : equalOrThreeDashes(n)} ${getLabelMessage('campaigns:currency')}`,
		formatNumber,
		roundNumber(decimals),
	)(number);

export const phone = (number) => {
	if (isNil(number)) {
		return null;
	}

	return compose(
		checkPhoneLength,
		split(''),
		replace(/\s/g, ''),
		String,
	)(number).reduce((acc, value, index) => (index > 0 && index % 3 === 0 ? `${acc} ${value}` : `${acc}${value}`), '');
};

export const percentage = (value) => (isNilOrEmptyString(value) ? '--- %' : `${formatNumber(value)} %`);

const isBlank = (str) => {
	return !str || /^\s*$/.test(str);
};

export const currencyViewParser = (value) => {
	return !isBlank(value) && isNumeric(Number(value)) && value.toString().slice(-1) !== '.' ? currency(value) : value;
};
